import moment from "../vendor/moment";

export default {
  elements: {},
  init() {
    var app = angular.module("sentencing");

    app.config(function ($interpolateProvider) {
      $interpolateProvider.startSymbol("<%");
      $interpolateProvider.endSymbol("%>");
    });

    app.controller(
      "SentencingDrinkDrivingCalcualtorCtrl",
      function ($timeout, $scope) {
        //$scope.disqualificationDate
        // $scope.disqualificationDays = 0;
        $scope.disqualificationMonths = 12;
        // $scope.disqualificationYears = 0;
        $scope.custodialDays = 0;
        $scope.custodialWeeks = 0;
        // $scope.custodialMonths = 0;
        // $scope.custodialYears = 0;

        $scope.debug_sentenceDate = "";
        $scope.debug_disqualificationEndDate = "";
        $scope.debug_custodialEndDate = "";
        $scope.debug_custodialDurationDays = 0;
        $scope.debug_disqualificationDays = 0;
        $scope.debug_extensionDays = 0;
        $scope.debug_reductionDays = 0;
        $scope.debug_hasCustodialSentence = "";
        $scope.debug_qualifiesForReduction = "";

        $scope.outputCourseEnd = "";
        $scope.outputReduction = "";
        $scope.outputEndWithReduction = "";
        $scope.outputEndWithoutReduction = "";

        $scope.resetDrinkDrive = function () {
          console.log("I was here ...");
          $scope.disqualificationMonths = 12;
          // $scope.disqualificationYears = 0;
          $scope.custodialDays = 0;
          $scope.custodialWeeks = 0;
          // $scope.custodialMonths = 0;
          // $scope.custodialYears = 0;

          $scope.debug_sentenceDate = "";
          $scope.debug_disqualificationEndDate = "";
          $scope.debug_custodialEndDate = "";
          $scope.debug_custodialDurationDays = 0;
          $scope.debug_disqualificationDays = 0;
          $scope.debug_extensionDays = 0;
          $scope.debug_reductionDays = 0;
          $scope.debug_hasCustodialSentence = "";
          $scope.debug_qualifiesForReduction = "";

          $scope.outputCourseEnd = "";
          $scope.outputReduction = "";
          $scope.outputEndWithReduction = "";
          $scope.outputEndWithoutReduction = "";
          $("#datepicker").datepicker().datepicker("setDate", new Date());
          $timeout(function () {
            $("#hideLengthOfCustodialSentence").trigger("click");
          }, 0);
          $scope.updateDrinkDrive();
        };

        $scope.updateDrinkDrive = function () {
          console.log("calculating ...");

          function advanceDate(startDate, years, months, days) {
            return moment(startDate)
              .add(years, "years")
              .add(months, "months")
              .add(days, "days");
          }

          function daysDifference(startDate, endDate) {
            var totalDays = moment(endDate).diff(startDate, "days");
            return parseInt(totalDays);
          }

          function monthsDifference(startDate, endDate) {
            var totalMonths = moment(endDate).diff(startDate, "months");
            return partsInt(totalMonths);
          }

          function formatDifference(startDate, endDate) {
            var count = moment(startDate);

            var years = endDate.diff(count, "years");
            count.add(years, "years");
            var months = endDate.diff(count, "months");
            count.add(months, "months");
            var days = endDate.diff(count, "days");

            var parts = [];
            if (years > 0) {
              parts.push(`${years} ${years > 1 ? "years" : "year"}`);
            }
            if (months > 0) {
              parts.push(`${months} ${months > 1 ? "months" : "month"}`);
            }
            if (days > 0) {
              parts.push(`${days} ${days > 1 ? "days" : "day"}`);
            }
            return parts.join(", ");
          }

          // get the inputs
          var reductionFactor = 0.25;
          var reductionThresholdDays = 365;

          var sentenceDate = moment($scope.disqualificationDate);
          // var custodialEndDate = advanceDate(sentenceDate, $scope.custodialYears, $scope.custodialMonths, $scope.custodialDays);
          var custodialEndDate = advanceDate(
            sentenceDate,
            0,
            0,
            parseInt($scope.custodialDays) + parseInt($scope.custodialWeeks) * 7
          );
          // var disqualificationEndDate = advanceDate(sentenceDate, $scope.disqualificationYears, $scope.disqualificationMonths, $scope.disqualificationDays);
          var disqualificationEndDate = advanceDate(
            sentenceDate,
            0,
            parseInt($scope.disqualificationMonths),
            0
          );

          var custodialDurationDays = daysDifference(
            sentenceDate,
            custodialEndDate
          );
          var disqualificationDays = daysDifference(
            sentenceDate,
            disqualificationEndDate
          );
          var disqualificationMonths = parseInt($scope.disqualificationMonths); // monthsDifference(sentenceDate, disqualificationEndDate);

          // calculate the extension
          var extensionDays = Math.floor(custodialDurationDays / 2) - 1;

          // calculate the reduction
          var qualifiesForReduction =
            disqualificationDays >= reductionThresholdDays;
          var disqualificationEndDateWithoutReduction = moment(
            disqualificationEndDate
          ).add(extensionDays, "days");

          // var reductionDays = qualifiesForReduction ? Math.floor(disqualificationDays * reductionFactor) : 0;
          var reductionDays = qualifiesForReduction
            ? 7 * disqualificationMonths
            : 0;
          var reductionWeeks = Math.floor(reductionDays / 7);
          var disqualificationEndDateWithReduction = moment(
            disqualificationEndDate
          )
            .subtract(reductionDays, "days")
            .add(extensionDays, "days");
          // .subtract(1, 'days');

          // special case for 12 months
          if (disqualificationMonths == 12) {
            disqualificationEndDateWithReduction = moment(
              disqualificationEndDate
            )
              .subtract(3, "months")
              .add(extensionDays, "days");
          }

          // calculate the course to be completed by
          var hasCustodialSentence = custodialDurationDays > 0;
          var courseEndDate = moment(
            disqualificationEndDateWithReduction
          ).subtract(2, "months");

          // debug outputs
          $scope.debug_sentenceDate = sentenceDate.format("DD MMMM YYYY");
          $scope.debug_disqualificationEndDate =
            disqualificationEndDate.format("DD MMMM YYYY");
          $scope.debug_custodialEndDate =
            custodialEndDate.format("DD MMMM YYYY");
          $scope.debug_custodialDurationDays = custodialDurationDays;
          $scope.debug_disqualificationDays = disqualificationDays;
          $scope.debug_extensionDays = extensionDays;
          $scope.debug_reductionDays = reductionDays;
          $scope.debug_hasCustodialSentence = hasCustodialSentence
            ? "Yes"
            : "No";
          $scope.debug_qualifiesForReduction = qualifiesForReduction
            ? "Yes"
            : "No";

          // format the outputs
          $scope.outputCourseEnd = courseEndDate.format("DD MMMM YYYY");
          if (disqualificationMonths < 12) {
            $scope.outputCourseEnd = "Not applicable";
          }

          if (qualifiesForReduction) {
            var formattedReduction = formatDifference(
              disqualificationEndDateWithReduction,
              disqualificationEndDateWithoutReduction
            );
            // $scope.outputReduction = `${reductionDays} days = ${formattedReduction}`;
            if (disqualificationMonths == 12) {
              $scope.outputReduction = "3 months";
            } else {
              $scope.outputReduction = `${reductionWeeks} weeks`;
            }

            var endWithReduction =
              disqualificationEndDateWithReduction.format("DD MMMM YYYY");
            var durationWithReduction = formatDifference(
              sentenceDate,
              disqualificationEndDateWithReduction
            );
            $scope.outputEndWithReduction = `${endWithReduction}`;
          } else {
            $scope.outputReduction = "No reduction";
            $scope.outputEndWithReduction = "No reduction";
          }

          var endWithoutReduction =
            disqualificationEndDateWithoutReduction.format("DD MMMM YYYY");
          var durationWithoutReduction = formatDifference(
            sentenceDate,
            disqualificationEndDateWithoutReduction
          );
          $scope.outputEndWithoutReduction = `${endWithoutReduction}`;

          console.log("Calculated.");
          $(".output-section").addClass("ready");
        };

        $(function () {
          $("#datepicker").datepicker({
            showOn: "button",
            buttonImage: "/wp-content/themes/sage/dist/images/calendar.png",
            buttonImageOnly: true,
            buttonText: "Select date",
          });
          $("#datepicker").datepicker().datepicker("setDate", new Date());

          //var moment = require('moment');
        });

        // $(function () {$scope.updateDrinkDrive()});
        $scope.updateDrinkDrive();

        // interaction
        $scope.hideLengthOfCustodialSentence = function () {
          // $scope.custodialDays_b = $scope.custodialDays;
          // $scope.custodialMonths_b = $scope.custodialMonths;
          // $scope.custodialYears_b = $scope.custodialYears;
          $scope.custodialDays = 0;
          $scope.custodialWeeks = 0;
          // $scope.custodialMonths = 0;
          // $scope.custodialYears = 0;
          jQuery(".lengthOfCustodianSentence")
            .addClass("disable")
            .find("input")
            .prop("disabled", true);
          jQuery("#hideLengthOfCustodialSentence").addClass("active");
          jQuery("#showLengthOfCustodialSentence").removeClass("active");
          console.log("Hide");
          $scope.updateDrinkDrive();
        };

        $scope.showLengthOfCustodialSentence = function () {
          jQuery(".lengthOfCustodianSentence")
            .removeClass("disable")
            .find("input")
            .prop("disabled", false);
          jQuery("#showLengthOfCustodialSentence").addClass("active");
          jQuery("#hideLengthOfCustodialSentence").removeClass("active");
          console.log("Show");
          $scope.updateDrinkDrive();
        };
      }
    );
  },
};



// WEBPACK FOOTER //
// ./scripts/components/drink-drive.js